import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Route, withRouter } from 'react-router-dom'
import setAllReferencesDataAction from '../actions/setAllReferencesData'
import setAllReferencesFiltersAction from '../actions/setAllReferencesFilters'
import setModalDataAction from '../actions/setModalData'
import getAllReferences from '../api/getAllReferences'
import getOneReference from '../api/getOneReference'
import getReferencesByType from '../api/getReferencesByType'
import HeaderTitle from '../components/HeaderTitle.jsx'
import Button from '../components/Button.jsx'
import ReferencesFilters from '../components/ReferencesFilters.jsx'
import ReferencesList from '../components/ReferencesList.jsx'
import ModalContainer from '../containers/ModalContainer.jsx'

class ReferencesContainer extends Component {
    state = {
        activeFilter: 0,
        isSeeMoreClicked: false,
        modalData: {}
    }

    componentDidMount() {
        if (this.props.filters.length < 1) {
            getAllReferences()
                .then((data) => {
                    this.setAllReferences(data)
                    setTimeout(() => {
                        this.props.setAllReferencesFiltersAction(data, this.props.activeLang)
                    }, 300)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    componentWillUnmount() {
        this.props.setAllReferencesDataAction([])
        this.props.setAllReferencesFiltersAction([])
    }

    static listFetch = (store, params) => getAllReferences()
        .then((data) => {
            store.dispatch(setAllReferencesDataAction(data))
            store.dispatch(setAllReferencesFiltersAction(data, params.lang))
        }).catch(() => {})

    static modalFetch = (store, params) => {
        const id = parseInt(params.id, 10) || -1
        if (id !== -1) {
            return getOneReference(id)
                .then((data) => {
                    store.dispatch(setModalDataAction(data))
                })
                .catch(() => {})
        }
        return Promise.resolve()
    }

    setAllReferences = (data) => {
        setTimeout(() => {
            this.props.setAllReferencesDataAction(data)
        }, 500)
    }

    setActiveFilter = (id, filterName) => {
        this.setState({
            activeFilter: id
        })
        this.props.setAllReferencesDataAction([])
        this.handleSeeMoreClick(false)
        if (id === 0) {
            getAllReferences()
                .then((data) => {
                    this.setAllReferences(data)
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            getReferencesByType(filterName)
                .then((data) => {
                    console.log('dd: ', data)
                    this.setAllReferences(data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    handleSeeMoreClick = (bool) => {
        this.setState({
            isSeeMoreClicked: bool
        })
    }

    setModalData = (data) => {
        this.props.setModalDataAction(data)
    }

    render() {
        let referencesListArr = this.props.referencesData.slice(0, 6)
        if (this.state.isSeeMoreClicked) {
            referencesListArr = this.props.referencesData
        }
        let seeMoreBtn = ''
        if (this.props.referencesData.length > 6 && referencesListArr.length !== this.props.referencesData.length) {
            seeMoreBtn = (
                <div className="col-md-12">
                    <div className="see-more-btn">
                        <Button
                            type="yellow"
                            text={this.props.langData.btnText}
                            onClick={this.handleSeeMoreClick.bind(null, true)}
                        />
                    </div>
                </div>
            )
        }

        return (
            <div className="section-spacing section-spacing--first">
                <HeaderTitle
                    className="header1--center"
                    title={this.props.langData.title}
                />
                <div className="container">
                    <div className="row">
                        <ReferencesFilters
                            filterData={this.props.filters}
                            allFilterText={this.props.langData.allFilterText}
                            filterTitle={this.props.langData.filterTitle}
                            activeFilter={this.state.activeFilter}
                            setActiveFilter={this.setActiveFilter}
                        />
                        <ReferencesList
                            itemsData={referencesListArr}
                            setModalData={this.setModalData}
                            path="/reference"
                        />
                    </div>
                    {seeMoreBtn}
                </div>

                <Route
                    exact
                    path="/reference/:id"
                >
                    <ModalContainer data={this.props.modalData} />
                </Route>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.references,
    activeLang: state.activeLang,
    referencesData: state.allReferencesData,
    filters: state.allReferencesFilters,
    modalData: state.modalData
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setAllReferencesDataAction,
    setAllReferencesFiltersAction,
    setModalDataAction
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReferencesContainer))



// WEBPACK FOOTER //
// ./src/scripts/containers/ReferencesContainer.jsx